export default __webpack_public_path__ + "static/Entenda0023-a128355a9c04ede9827bbde4e387f590.jpg";